import type { PhotoGridProps } from '@/app/components/PhotoGrid/types';

export const mobilePhotoGrid: PhotoGridProps = {
  className: 'grid-cols-4 md:grid-cols-6',
  columns: [
    {
      colSpan: 2,
      id: 'mobile-grid-col-1',
      items: [
        {
          alt: 'pop_membership_activity_and_fitness_featured_img_alt',
          dimensions: { height: 600, width: 400 },
          id: 'mobile-grid-col-1-item-1',
          offset: { x: 0.51, y: 0.49 },
          src: 'blue-sky/pop/lifestyle_photo_grid_4.jpg',
        },
        {
          alt: 'pop_membership_womens_health_featured_img_alt',
          dimensions: { height: 600, width: 400 },
          id: 'mobile-grid-col-1-item-2',
          offset: { x: 0.56, y: 0.5 },
          src: 'blue-sky/pop/lifestyle_photo_grid_3.jpg',
          trimColor: '0a031d',
          zoom: 1.1,
        },
      ],
    },
    {
      className: 'translate-y-16',
      colSpan: 2,
      id: 'mobile-grid-col-2',
      items: [
        {
          alt: 'pop_lifestyle_smiling_man_image_alt',
          dimensions: { height: 600, width: 400 },
          id: 'mobile-grid-col-2-item-1',
          src: 'blue-sky/pop/lifestyle_photo_grid_5.jpg',
        },
        {
          alt: 'pop_lifestyle_soldier_image_alt',
          dimensions: { height: 600, width: 400 },
          id: 'mobile-grid-col-2-item-2',
          offset: { x: 0.52, y: 0.5 },
          src: 'blue-sky/pop/lifestyle_photo_grid_6.jpg',
        },
      ],
    },
    {
      className: 'hidden translate-y-8 md:flex',
      colSpan: 2,
      id: 'mobile-grid-col-3',
      items: [
        {
          alt: 'pop_lifestyle_doctor_image_alt',
          dimensions: { height: 600, width: 400 },
          id: 'mobile-grid-col-3-item-1',
          src: 'blue-sky/pop/lifestyle_photo_grid_1.jpg',
        },
        {
          alt: 'pop_lifestyle_office_image_alt',
          dimensions: { height: 600, width: 400 },
          id: 'mobile-grid-col-3-item-2',
          offset: { x: 0.52, y: 0.5 },
          src: 'blue-sky/pop/lifestyle_photo_grid_2.jpg',
        },
      ],
    },
  ],
};

export const desktopPhotoGrid: PhotoGridProps = {
  className: 'pl-10 grid-cols-11 w-[125vw] max-w-[1800px]',
  columns: [
    {
      colSpan: 2,
      id: 'desktop-grid-col-1',
      items: [
        {
          alt: 'pop_lifestyle_doctor_image_alt',
          dimensions: { height: 380, width: 304 },
          id: 'desktop-grid-col-1-item-1',
          offset: { x: 0.35, y: 0.55 },
          src: 'blue-sky/pop/lifestyle_photo_grid_1.jpg',
          zoom: 1.15,
        },
        {
          alt: 'pop_lifestyle_office_image_alt',
          className: '-scale-x-100',
          dimensions: { height: 280, width: 304 },
          id: 'desktop-grid-col-1-item-2',
          offset: { x: 0.65, y: 0.7 },
          src: 'blue-sky/pop/lifestyle_photo_grid_2.jpg',
          zoom: 1.3,
        },
      ],
    },
    {
      colSpan: 2,
      id: 'desktop-grid-col-2',
      items: [
        {
          alt: 'pop_membership_womens_health_featured_img_alt',
          dimensions: { height: 458, width: 304 },
          id: 'desktop-grid-col-2-item-1',
          offset: { x: 0.56, y: 0.5 },
          src: 'blue-sky/pop/lifestyle_photo_grid_3.jpg',
          trimColor: '0a031d',
          zoom: 1.1,
        },
      ],
    },
    {
      colSpan: 2,
      id: 'desktop-grid-col-3',
      items: [
        {
          alt: 'pop_membership_activity_and_fitness_featured_img_alt',
          dimensions: { height: 358, width: 304 },
          id: 'desktop-grid-col-3-item-1',
          offset: { x: 0.52, y: 0.5 },
          src: 'blue-sky/pop/lifestyle_photo_grid_4.jpg',
        },
      ],
    },
    {
      colSpan: 3,
      id: 'desktop-grid-col-4',
      items: [
        {
          alt: 'pop_lifestyle_smiling_man_image_alt',
          dimensions: { height: 490, width: 476 },
          id: 'desktop-grid-col-4-item-1',
          src: 'blue-sky/pop/lifestyle_photo_grid_5.jpg',
        },
      ],
    },
    {
      colSpan: 2,
      id: 'desktop-grid-col-5',
      items: [
        {
          alt: 'pop_lifestyle_soldier_image_alt',
          dimensions: { height: 380, width: 304 },
          id: 'desktop-grid-col-5-item-1',
          offset: { x: 0.68, y: 0.5 },
          src: 'blue-sky/pop/lifestyle_photo_grid_6.jpg',
        },
        {
          alt: 'pop_lifestyle_book_image_alt',
          dimensions: { height: 380, width: 304 },
          id: 'desktop-grid-col-5-item-2',
          offset: { x: 0.62, y: 0.6 },
          src: 'blue-sky/pop/lifestyle_photo_grid_7.jpg',
          zoom: 1.5,
        },
      ],
    },
  ],
};
